import React from 'react';
import "./authLogoModal.scss";
import { UtilService } from "../../../services/UtilService";
import { ReactComponent as LogoSVG } from "../../../../node_modules/itd-common/assets/images/brand/logo.svg";

const BrandLogo: React.FC = () => {
  return (
    <div className="brand-logo-container mb-4" >
      <LogoSVG className="brand-logo-container__image" />
        {UtilService.isMobilePlatform() ? <span className="mx-2"></span> : <div className='divider'></div>}
      <h4 >Merchant center</h4>
    </div>
  );
};

export default BrandLogo;
